export default __webpack_public_path__ + "static/media/pedaIconEmpty.d6fcad22.svg";